export const INDIVIDUAL = "Indywidualne ustalenie";

// Domyślne progi haftu — obowiązują dla każdego produktu z techniką „Haft",
// chyba że produkt ma własne progi (rules[sku].haft).
export const DEFAULT_HAFT = { przod: 15, tyl: 35, oba: 45 };

export function commissionPerPiece(sku, price, branding = "", placements = [], rules = {}) {
  const r = rules[sku];
  const p = Number(price) || 0;
  if (!r) return { commission: 0, note: INDIVIDUAL };
  let comm = null;
  const tiers = [...(r.tiers || [])].sort((a, b) => Number(b.min_price) - Number(a.min_price));
  for (const t of tiers) { if (p >= Number(t.min_price)) { comm = Number(t.commission); break; } }
  if (comm === null) {
    const n = Number(r.below);
    if (r.below === "individual" || r.below == null || Number.isNaN(n)) return { commission: 0, note: INDIVIDUAL };
    comm = n;
  }
  return { commission: comm, note: "" };
}

const zl = (n) => `${Number(n).toString().replace(".", ",")} zł`;

export function haftSurcharge(sku, branding = "", placements = [], rules = {}) {
  if (!String(branding).toLowerCase().includes("haft")) return 0;
  const h = (rules[sku] || {}).haft || DEFAULT_HAFT;
  const pl = (placements || []).map((p) => String(p).toLowerCase());
  const front = pl.some((p) => p.includes("przód") || p.includes("przod"));
  const back = pl.some((p) => p.includes("tył") || p.includes("tyl"));
  if (front && back) return Number(h.oba) || 0;
  if (back) return Number(h.tyl) || 0;
  if (front) return Number(h.przod) || 0;
  return 0;
}

export function haftAddForItem(sku, branding, rules = {}) {
  const b = branding || {};
  if (!String(b.type || "").toLowerCase().includes("haft")) return 0;
  if (b.haft_custom) return Number(b.haft_custom_price) || 0;
  return haftSurcharge(sku, b.type, b.placements || [], rules);
}


export function tierChips(sku, rules = {}) {
  const r = rules[sku];
  if (!r) return [];
  const tiers = [...(r.tiers || [])].sort((a, b) => Number(b.min_price) - Number(a.min_price));
  const chips = tiers.map((t) => ({ threshold: `≥ ${zl(t.min_price)}`, reward: zl(t.commission) }));
  const lowest = tiers.length ? tiers[tiers.length - 1].min_price : null;
  if (lowest != null) {
    const n = Number(r.below);
    if (r.below === "individual" || r.below == null || Number.isNaN(n)) chips.push({ threshold: `< ${zl(lowest)}`, reward: "indyw." });
    else chips.push({ threshold: `< ${zl(lowest)}`, reward: zl(r.below) });
  }
  if (r.haft || true) {
    const h = r.haft || DEFAULT_HAFT;
    if (Number(h.przod)) chips.push({ threshold: "Haft przód", reward: `+${zl(h.przod)}` });
    if (Number(h.tyl)) chips.push({ threshold: "Haft tył", reward: `+${zl(h.tyl)}` });
    if (Number(h.oba)) chips.push({ threshold: "Haft przód+tył", reward: `+${zl(h.oba)}` });
  }
  return chips;
}
